import {PaymentMethodProps} from "../typings/wc-types";
import {WigWagSettings} from "./types";

export default function WigWagPaymentMethod(_props: PaymentMethodProps) {
    const settings = window.wc.wcSettings.getSetting<WigWagSettings>('wigwag_data');

    return (
        <img src={settings.icon_url} alt="Pay securely with WigWag"/>
    );
}
